import { JunctionInfo } from '../junction.info';
import { RoadMap } from './road.map';

export class AbacusNd3Map extends RoadMap {

    protected junctionInfos: Array<JunctionInfo> = [
        {id: 0, x: 30, y: 30, connectedTo: []} as JunctionInfo,
        {id: 1, x: 35, y: 60, connectedTo: [0]} as JunctionInfo,
        {id: 2, x: 85, y: 65, connectedTo: [1]} as JunctionInfo,
        {id: 3, x: 95, y: 35, connectedTo: [2, 0]} as JunctionInfo,
        {id: 4, x: 140, y: 35, connectedTo: [3]} as JunctionInfo,
        {id: 5, x: 175, y: 23, connectedTo: [4]} as JunctionInfo,
        {id: 6, x: 235, y: 43, connectedTo: [5]} as JunctionInfo,
        {id: 7, x: 245, y: 53, connectedTo: [6]} as JunctionInfo,
        {id: 8, x: 195, y: 53, connectedTo: [7]} as JunctionInfo,
        {id: 9, x: 172, y: 53, connectedTo: [7, 2]} as JunctionInfo,
        {id: 10, x: 172, y: 83, connectedTo: [9]} as JunctionInfo,
        {id: 11, x: 30, y: 83, connectedTo: [10, 1]} as JunctionInfo,
        {id: 12, x: 30, y: 123, connectedTo: [11]} as JunctionInfo,
        {id: 13, x: 60, y: 123, connectedTo: [12]} as JunctionInfo,
        {id: 14, x: 90, y: 123, connectedTo: [13]} as JunctionInfo,
        {id: 15, x: 120, y: 123, connectedTo: [14, 10]} as JunctionInfo,
        {id: 16, x: 120, y: 153, connectedTo: [15]} as JunctionInfo,
        {id: 17, x: 90, y: 193, connectedTo: [16]} as JunctionInfo,
        {id: 18, x: 30, y: 193, connectedTo: [17]} as JunctionInfo,
        {id: 19, x: 30, y: 163, connectedTo: [18, 12, 16]} as JunctionInfo,
        {id: 20, x: 30, y: 253, connectedTo: [18, 17]} as JunctionInfo,
        {id: 21, x: 45, y: 293, connectedTo: [20]} as JunctionInfo,
        {id: 22, x: 65, y: 363, connectedTo: [21]} as JunctionInfo,
        {id: 23, x: 20, y: 323, connectedTo: [21]} as JunctionInfo,
        {id: 24, x: 75, y: 463, connectedTo: [22]} as JunctionInfo,
        {id: 25, x: 120, y: 563, connectedTo: [24]} as JunctionInfo,
        
        {id: 26, x: 220, y: 133, connectedTo: [14, 7]} as JunctionInfo,
        {id: 27, x: 200, y: 163, connectedTo: [26, 16]} as JunctionInfo,
        {id: 28, x: 190, y: 193, connectedTo: [27, 18]} as JunctionInfo,
        {id: 29, x: 190, y: 223, connectedTo: [28]} as JunctionInfo,
        {id: 30, x: 180, y: 263, connectedTo: [29, 21]} as JunctionInfo,
        {id: 31, x: 170, y: 293, connectedTo: [30]} as JunctionInfo,
        {id: 32, x: 160, y: 343, connectedTo: [31]} as JunctionInfo,
        {id: 33, x: 150, y: 373, connectedTo: [32]} as JunctionInfo,
        {id: 34, x: 140, y: 423, connectedTo: [33, 24, 25]} as JunctionInfo,
        {id: 35, x: 240, y: 423, connectedTo: [34]} as JunctionInfo,
        {id: 36, x: 200, y: 603, connectedTo: [25]} as JunctionInfo,
        {id: 37, x: 240, y: 623, connectedTo: [36, 35]} as JunctionInfo,
        {id: 38, x: 340, y: 630, connectedTo: [37]} as JunctionInfo,
        {id: 39, x: 440, y: 630, connectedTo: [38]} as JunctionInfo,
        {id: 40, x: 590, y: 640, connectedTo: [39]} as JunctionInfo,
        {id: 41, x: 790, y: 645, connectedTo: [40]} as JunctionInfo,
        {id: 42, x: 890, y: 645, connectedTo: [41]} as JunctionInfo,
    ];


    constructor() {
        super();
        this.convertJunctionInfosToJunctionObjects(this.junctionInfos);
        this.addAllTwoWayConnections();
    }
    

}